(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-slider"] && !Shopify.designMode) return;
  try {
    
  class ContentSlider {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-slider-track]');
      this.slides = [...section.querySelectorAll('.content-slider__slide')];
      this.indicators = [...section.querySelectorAll('[data-indicator-index]')];
      this.prevBtns = [...section.querySelectorAll('[data-slider-prev]')];
      this.nextBtns = [...section.querySelectorAll('[data-slider-next]')];
      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.atEnd = false;
      this.hasPeek = false;
      this.peekClone = null;
      this.isFullScreen = this.section.dataset.fullScreen === 'true';

      if (this.totalSlides <= 1) return;

      this.setupPeek();
      this.bindEvents();
      this.update();
    }

    setupPeek() {
      if (this.section.dataset.peekLeft !== 'true') return;

      const firstSlide = this.slides[0];
      const slideWidth = firstSlide.offsetWidth;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const trackWidth = this.track.offsetWidth;
      const visibleCount = Math.max(1, Math.floor((trackWidth + gap) / (slideWidth + gap)));

      if (this.totalSlides <= visibleCount) return;

      const lastSlide = this.slides[this.slides.length - 1];
      const clone = lastSlide.cloneNode(true);
      clone.classList.add('content-slider__slide--peek-clone');
      clone.classList.remove('content-slider__slide--active');
      clone.removeAttribute('data-slide-index');
      clone.setAttribute('aria-hidden', 'true');
      this.track.prepend(clone);

      this.hasPeek = true;
      this.peekClone = clone;
    }

    refreshPeek() {
      if (this.peekClone) {
        this.peekClone.remove();
        this.peekClone = null;
        this.hasPeek = false;
      }
      this.setupPeek();
      this.update();
    }

    bindEvents() {
      this.prevBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.prev());
      });
      this.nextBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.next());
      });
      this.indicators.forEach((indicator) => {
        indicator.addEventListener('click', () => {
          const index = parseInt(indicator.dataset.indicatorIndex, 10);
          this.atEnd = false;
          this.goTo(index);
        });
      });

      let startX = 0;
      let diff = 0;
      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });
      this.track.addEventListener('touchmove', (e) => {
        diff = e.touches[0].clientX - startX;
      }, { passive: true });
      this.track.addEventListener('touchend', () => {
        if (Math.abs(diff) > 50) {
          if (diff < 0) {
            this.next();
          } else {
            this.prev();
          }
        }
        diff = 0;
      });

      if (this.section.dataset.peekLeft === 'true') {
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => this.refreshPeek(), 200);
        });
      }
    }

    getMaxOffset() {
      const lastSlide = this.slides[this.slides.length - 1];
      const trackWidth = this.track.offsetWidth;
      return Math.max(0, lastSlide.offsetLeft + lastSlide.offsetWidth - trackWidth);
    }

    next() {
      if (this.atEnd || this.currentIndex >= this.totalSlides - 1) {
        this.atEnd = false;
        this.goTo(0);
        return;
      }
      this.goTo(this.currentIndex + 1);
    }

    prev() {
      if (this.currentIndex === 0) {
        this.atEnd = true;
        this.goTo(this.totalSlides - 1);
        return;
      }
      this.atEnd = false;
      this.goTo(this.currentIndex - 1);
    }

    goTo(index) {
      if (index < 0) index = 0;
      if (index >= this.totalSlides) index = this.totalSlides - 1;
      this.currentIndex = index;
      this.update();
    }

    update() {
      const maxOffset = this.getMaxOffset();
      const slide = this.slides[this.currentIndex];
      let offset = slide.offsetLeft;

      if (offset >= maxOffset) {
        offset = maxOffset;
        this.atEnd = true;
      }

      this.track.style.transform = `translateX(${-offset}px)`;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('content-slider__slide--active', i === this.currentIndex);
      });

      this.indicators.forEach((indicator, i) => {
        indicator.classList.toggle('content-slider__indicator--active', i === this.currentIndex);
        indicator.setAttribute('aria-current', i === this.currentIndex ? 'true' : 'false');
      });
    }
  }

  document.querySelectorAll('.content-slider').forEach((section) => {
    new ContentSlider(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollectionSlider {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-fc-track]');
      this.slides = [...section.querySelectorAll('.fc-slider__slide')];
      this.allIndicators = [...section.querySelectorAll('[data-indicator-index]')];
      this.prevBtns = [...section.querySelectorAll('[data-fc-prev]')];
      this.nextBtns = [...section.querySelectorAll('[data-fc-next]')];
      this.currentPage = 0;
      this.totalSlides = this.slides.length;
      this.pageCount = 1;

      this.colsDesktop = parseInt(section.dataset.columnsDesktop, 10) || 3;
      this.colsMobile = parseInt(section.dataset.columnsMobile, 10) || 1;

      if (this.totalSlides <= 1) return;

      this.bindEvents();
      this.onResize();
      window.addEventListener('resize', () => this.onResize());
    }

    getVisibleCols() {
      return window.innerWidth >= 1080 ? this.colsDesktop
        : window.innerWidth >= 600 ? Math.min(this.colsDesktop, 2)
        : this.colsMobile;
    }

    needsSlider() {
      return this.totalSlides > this.getVisibleCols();
    }

    getPageCount() {
      var cols = this.getVisibleCols();
      return Math.max(1, this.totalSlides - cols + 1);
    }

    onResize() {
      this.pageCount = this.getPageCount();

      if (!this.needsSlider()) {
        this.track.style.transform = '';
        this.currentPage = 0;
        this.section.classList.remove('fc-slider--active');
        this.syncIndicators();
        return;
      }

      this.section.classList.add('fc-slider--active');
      if (this.currentPage >= this.pageCount) {
        this.currentPage = this.pageCount - 1;
      }
      this.syncIndicators();
      this.update();
    }

    syncIndicators() {
      this.allIndicators.forEach(function(ind, i) {
        if (i < this.pageCount) {
          ind.style.display = '';
        } else {
          ind.style.display = 'none';
        }
      }.bind(this));
    }

    bindEvents() {
      this.prevBtns.forEach(function(btn) {
        btn.addEventListener('click', function() { this.prev(); }.bind(this));
      }.bind(this));
      this.nextBtns.forEach(function(btn) {
        btn.addEventListener('click', function() { this.next(); }.bind(this));
      }.bind(this));
      this.allIndicators.forEach(function(indicator) {
        indicator.addEventListener('click', function() {
          var index = parseInt(indicator.dataset.indicatorIndex, 10);
          this.goTo(index);
        }.bind(this));
      }.bind(this));

      var startX = 0;
      var diff = 0;
      this.track.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      this.track.addEventListener('touchmove', function(e) {
        diff = e.touches[0].clientX - startX;
      }, { passive: true });
      this.track.addEventListener('touchend', function() {
        if (Math.abs(diff) > 50) {
          diff < 0 ? this.next() : this.prev();
        }
        diff = 0;
      }.bind(this));
    }

    getMaxOffset() {
      var lastSlide = this.slides[this.slides.length - 1];
      var trackWidth = this.track.offsetWidth;
      return Math.max(0, lastSlide.offsetLeft + lastSlide.offsetWidth - trackWidth);
    }

    next() {
      if (!this.needsSlider()) return;
      if (this.currentPage >= this.pageCount - 1) {
        this.goTo(0);
        return;
      }
      this.goTo(this.currentPage + 1);
    }

    prev() {
      if (!this.needsSlider()) return;
      if (this.currentPage <= 0) {
        this.goTo(this.pageCount - 1);
        return;
      }
      this.goTo(this.currentPage - 1);
    }

    goTo(page) {
      if (page < 0) page = 0;
      if (page >= this.pageCount) page = this.pageCount - 1;
      this.currentPage = page;
      this.update();
    }

    update() {
      if (!this.needsSlider()) return;

      var maxOffset = this.getMaxOffset();
      var slide = this.slides[this.currentPage];
      var offset = slide.offsetLeft;

      if (offset >= maxOffset) {
        offset = maxOffset;
      }

      this.track.style.transform = 'translateX(' + (-offset) + 'px)';
      this.updateIndicators();
    }

    updateIndicators() {
      var current = this.currentPage;
      this.allIndicators.forEach(function(indicator, i) {
        var isActive = i === current;
        indicator.classList.toggle('fc-slider__indicator--active', isActive);
        indicator.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
  }

  document.querySelectorAll('[data-fc-slider]').forEach(function(section) {
    new FeaturedCollectionSlider(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type')
=== 'reduce-logo-size';
this.headerBounds = {};

this.setHeaderHeight();

window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
};

this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

setHeaderHeight() {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop> this.headerBounds.bottom) {
  this.header.classList.add('scrolled-past-header');
  if (!this.preventReveal) {
  requestAnimationFrame(this.reveal.bind(this));
  } else {
  window.clearTimeout(this.isScrolling);

  this.isScrolling = setTimeout(() => {
  this.preventReveal = false;
  }, 66);

  requestAnimationFrame(this.hide.bind(this));
  }
  } else if (scrollTop <= this.headerBounds.top) { this.header.classList.remove('scrolled-past-header');
    requestAnimationFrame(this.reset.bind(this)); } this.currentScrollTop=scrollTop; } hide() { if
    (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky' );
    this.closeMenuDisclosure(); this.closeSearchModal(); } reveal() { if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate' );
    this.header.classList.remove('shopify-section-header-hidden'); } reset() { if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky' , 'animate' ); }
    closeMenuDisclosure() { this.disclosures=this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure=> disclosure.close());
    }

    closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
    }
    }

    customElements.define('sticky-header', StickyHeader);
    
  } catch(e) { console.error(e); }
})();
})();
